export const ARTICLE_BASE_PATH = '/membership/associate-program'

export const ARTICLE_SECTIONS = {
  WELCOME: `${ARTICLE_BASE_PATH}/welcome`,
  QUALIFYING: `${ARTICLE_BASE_PATH}/qualifying-and-prerequisites`,
  LEVEL_1: `${ARTICLE_BASE_PATH}/level-1`,
  LEVEL_2: `${ARTICLE_BASE_PATH}/level-2`,
  LEVEL_3: `${ARTICLE_BASE_PATH}/level-3`,
  ELECTION: `${ARTICLE_BASE_PATH}/election-to-membership`,
}

export const ARTICLE_PATHS = {
  // General Info
  GETTING_HELP: `${ARTICLE_SECTIONS.WELCOME}/getting-help`,
  TIMEFRAME_DEADLINES: `${ARTICLE_SECTIONS.WELCOME}/timeframe-deadlines`,
  
  // Qualifying
  PLAYING_ABILITY_TEST: `${ARTICLE_SECTIONS.QUALIFYING}/playing-ability-test-pat`,
  
  // Level 1
  L1_COURSE_MANUALS: `${ARTICLE_SECTIONS.LEVEL_1}/l1-course-manuals`,
  L1_VIRTUAL_SEMINAR: `${ARTICLE_SECTIONS.LEVEL_1}/l1-virtual-seminar`,
  L1_PORTFOLIO: `${ARTICLE_SECTIONS.LEVEL_1}/l1-portfolio`,
  CAREER_PATHS: `${ARTICLE_SECTIONS.LEVEL_1}/career-paths`,
  EXPERIENCE_CREDITS: `${ARTICLE_SECTIONS.LEVEL_1}/work-experience-credits`,
  UNLOCKING_LEVEL_2: `${ARTICLE_SECTIONS.LEVEL_1}/unlocking-level-2`,
  
  // Level 2
  L2_COURSE_MANUALS: (careerPathSlug) => `${ARTICLE_SECTIONS.LEVEL_2}/${careerPathSlug}l2-course-manuals`,
  L2_SEMINAR: (careerPathSlug) => `${ARTICLE_SECTIONS.LEVEL_2}/${careerPathSlug}l2-seminar`,
  L2_PORTFOLIO: (careerPathSlug) => `${ARTICLE_SECTIONS.LEVEL_2}/${careerPathSlug}l2-portfolio`,
  UNLOCKING_LEVEL_3: `${ARTICLE_SECTIONS.LEVEL_2}/unlocking-level-3`,
  
  // Level 3
  L3_COURSE_MANUALS: (careerPathSlug) => `${ARTICLE_SECTIONS.LEVEL_3}/${careerPathSlug}l3-course-manuals`,
  L3_SEMINAR: (careerPathSlug) => `${ARTICLE_SECTIONS.LEVEL_3}/${careerPathSlug}l3-seminar`,
  L3_PORTFOLIO: (careerPathSlug) => `${ARTICLE_SECTIONS.LEVEL_3}/${careerPathSlug}l3-portfolio`,
  MEMBER_APPLICATION: `${ARTICLE_SECTIONS.ELECTION}/member-application`,
  ELECTION_SCHEDULE: `${ARTICLE_SECTIONS.ELECTION}/membership-election-dates`
}
